import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta-alt",
  "use": "icon-arrow--cta-alt-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 10\" id=\"icon-arrow--cta-alt\"><path d=\"M2.727 0a.909.909 0 1 0 0 1.82h4.147L.264 8.449a.909.909 0 0 0 1.29 1.281l6.627-6.64v4.179a.909.909 0 1 0 1.818 0V.908A.909.909 0 0 0 9.088 0H2.727Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol